export default "__VITE_ASSET__B2BBz7yK__"